import { Text } from '@trmediaab/zebra';
import { formatNumber, localStorage } from '@trmediaab/zebra-utils';

import Missing from '~/components/Elements/Missing';
import { EMPTY_VALUE_CHARACTER, formatPercentage } from '~/utils/numbers';
import Sentry from '~/utils/sentry';

export const Odds = ({ start, type }) =>
  start.odds.providers.ATG?.[type] != null ? (
    formatNumber(start.odds.providers.ATG[type] / 100, {
      minimumFractionDigits: 2,
    })
  ) : (
    <Missing />
  );

export const getShoeId = start => {
  let shoeId;

  if (start.shoe_id) {
    shoeId = start.shoe_id;
  } else if (
    start.preliminary_equipment &&
    start.preliminary_equipment.shoe_id
  ) {
    shoeId = start.preliminary_equipment.shoe_id;
  }

  return shoeId;
};

const StatsCell = ({ children, ...props }) => (
  <Text
    fontSize="1"
    sx={{
      display: 'block',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    }}
    {...props}
  >
    {children}
  </Text>
);

export const getRowStats = (stats, label) => {
  const cells = [];
  if (stats && stats.count > 0) {
    cells.push(
      <StatsCell fontWeight="semiBold">{label}</StatsCell>,
      <StatsCell textAlign="right">{stats.count}</StatsCell>,
      <StatsCell textAlign="right">{`${stats.plac1}-${stats.plac2}-${stats.plac3}`}</StatsCell>,
      <StatsCell textAlign="right">
        {formatPercentage(stats.plac1 / stats.count, { isDecimal: true })}
      </StatsCell>,
      <StatsCell textAlign="right">
        {formatPercentage(stats.roi, { isCent: true })}
      </StatsCell>,
    );

    return {
      cells,
    };
  }

  cells.push(
    <StatsCell fontWeight="semiBold">{label}</StatsCell>,
    <StatsCell textAlign="right">{EMPTY_VALUE_CHARACTER}</StatsCell>,
    <StatsCell textAlign="right">{EMPTY_VALUE_CHARACTER}</StatsCell>,
    <StatsCell textAlign="right">{EMPTY_VALUE_CHARACTER}</StatsCell>,
    <StatsCell textAlign="right">{EMPTY_VALUE_CHARACTER}</StatsCell>,
  );

  return {
    cells,
  };
};

export const VARIANT_THRESHOLDS = {
  mobile: 620,
  tabletCompact: 900,
  tablet: 1359,
  desktop: 1360,
};

export const isTablet = windowWidth =>
  windowWidth <= VARIANT_THRESHOLDS.tablet &&
  windowWidth > VARIANT_THRESHOLDS.tabletCompact;

export const isTabletCompact = windowWidth =>
  windowWidth <= VARIANT_THRESHOLDS.tabletCompact &&
  windowWidth < VARIANT_THRESHOLDS.tablet;

export const getVariant = windowWidth => {
  const width = Number(windowWidth);
  if (isTabletCompact(width)) {
    return 'tabletCompact';
  }
  if (isTablet(width)) {
    return 'tablet';
  }

  return 'desktop';
};

export const shouldExpandStart = () => {
  try {
    const storedValue = localStorage.get('shouldExpandStart');
    if (storedValue === null) {
      localStorage.set('shouldExpandStart', 'true');
      return true;
    }
    return storedValue === 'true';
  } catch (error) {
    Sentry.captureException(error);
    return false;
  }
};

export const setShouldExpandStart = () => {
  try {
    localStorage.set('shouldExpandStart', 'false');
  } catch (error) {
    Sentry.captureException(error);
  }
};
